import React from 'react';
import { withRouter } from "react-router-dom";
import AppContext from '../../AppContext'
import { Button, Form, FormGroup } from 'reactstrap';
import { isChrome } from 'react-device-detect';

import Slider from 'rc-slider';

import { FaHouseUser, FaChevronLeft, FaChevronDown, FaBed } from 'react-icons/fa';

import { withTranslation } from 'react-i18next';

import Menu from '../menu/menu';
import ToggleAudio from '../toggleAudio/toggleAudio';

import { isMobileSafari } from 'react-device-detect';
import MediaQuery from 'react-responsive'

import styles from '../../styles/controlPanel.module.css';
import 'rc-slider/assets/index.css';


class ControlPanel extends React.Component {
  
    constructor(props) {
        super(props)
        
        this.state = {
            audio: "audiofile.mp3",
            initialVolumeSet: false,
            initialLoad: false,
            selectedProduct: 0,
            gainNode: {},
            mediaSource: {},
            audioCtx: {},
        }
    }

    static contextType = AppContext

    componentDidMount() {

        this.checkDayNight()
        
    }

    playBackgroundAudio(source, volume) {

      const { appVolume, backgroundAudioLevels, ambientAudio, viewLocationPrevious, selectedBackgroundAudio, setSelectedBackgroundAudio, time, viewLocation } = this.context;

      var heatpump = document.getElementById("backgroundAudioContainer");
      
      if(source !== 'toggle') {
        if(source !== selectedBackgroundAudio || viewLocationPrevious === 'indoor') {
          heatpump.src = require(`../../assets/audio/${ source }`)

          setSelectedBackgroundAudio(source);
          
        }
        
        if(!isMobileSafari) {
          if(isChrome) {
            heatpump.volume = volume*appVolume;  
          } else {
            heatpump.volume = volume*appVolume;
          }

        } else {
          //for mobile safari
            if(this.state.initialVolumeSet) {
              this.gainNode.disconnect();

              this.gainNode = this.audioContext.createGain();
              this.gainNode.gain.value = volume*appVolume
              
              this.mediaSource.connect(this.gainNode);
              this.gainNode.connect(this.audioContext.destination);

              console.log("initially set");
          } else {
              if(ambientAudio) {
                heatpump.play();
              }
              
              this.audioContext = new (window.AudioContext || window.webkitAudioContext)();

                this.mediaSource = this.audioContext.createMediaElementSource(heatpump);
        
                this.gainNode = this.audioContext.createGain();
                this.gainNode.gain.value = volume*appVolume;
                    
                this.mediaSource.connect(this.gainNode);
                this.gainNode.connect(this.audioContext.destination);

                this.setState({initialVolumeSet: true})


              setTimeout(() => {
                
                this.audioContext.resume();

              },500);

              
          }
        }

      } else {
        if(time) {
          if(viewLocation === 'outdoor') {
            heatpump.volume = appVolume*backgroundAudioLevels['outdoorNight']
            
          } else {
            heatpump.volume = appVolume*backgroundAudioLevels['indoorNight']
          }
        } else {
          if(viewLocation === 'outdoor') {
            heatpump.volume = appVolume*backgroundAudioLevels['outdoorDay']
            
          } else {
            heatpump.volume = appVolume*backgroundAudioLevels['indoorDay']
          }
        }
      }
      
      if(volume !== 0) {
        if(ambientAudio) {
          heatpump.play();
        }
      } else {
        heatpump.pause();
      }
      
    }

    changeHeatpumpAudio =(location,volume,active,product) => {

      this.setState({selectedProduct: product});
      
      this.playHeatpumpAudio(location,volume,active,'menu',product);
    }

    async playHeatpumpAudio(view, volume, active, origin, menuProduct) {
        
      const { appVolume, heatpumpAudio, products, viewLocation, setHeatpumpVolume, setActiveView, setViewLocation, setViewLocationPrevious, time } = this.context;

      setHeatpumpVolume(volume);

      if(!origin) {
        setViewLocationPrevious(viewLocation);
        setViewLocation(view);
        setActiveView(active);
      }

      var heatpump = document.getElementById("heatpumpAudioContainer");

      if(origin) {
        if(heatpump.duration > 0 && !heatpump.paused) {
          await heatpump.pause();
        }
        
        var heatpumpInSrc = heatpump.src;
        heatpumpInSrc = heatpumpInSrc.replace(/^.*[\\\/]/, '');
        var heatpumpInSrcSplit = heatpumpInSrc.split('.');
        var heatpumpAudioDay = products[this.state.selectedProduct].audio[0];
        var heatpumpAudioNight = products[this.state.selectedProduct].audio[1];
        var heatpumpAudioDaySplit = heatpumpAudioDay.split('.');
        var heatpumpAudioNightSplit = heatpumpAudioNight.split('.');

        if(!time) {
          if(heatpumpAudioDaySplit[0] !== heatpumpInSrcSplit[0]) {
            heatpump.src = require(`../../assets/audio/${ products[this.state.selectedProduct].audio[0] }`)
          }
        } else {
          if(heatpumpAudioNightSplit[0] !== heatpumpInSrcSplit[0]) {
            heatpump.src = require(`../../assets/audio/${ products[this.state.selectedProduct].audio[1] }`)
          }
        }
      }

      if(!isMobileSafari) {
        heatpump.volume = volume*appVolume;

        if(heatpumpAudio) {
          heatpump.play();
        }

      } else {

        setTimeout(() => {
        console.log("AUDIO CTX HEATPUMP AUDIO")
        console.log(this.props.audioCtx)
        console.log(this.props.mediaSrc)
        console.log(this.props.gainNode)
        
        if(heatpumpAudio) {
          heatpump.play();
        }

        this.props.gainNode.disconnect();

        this.props.gainNode.gain.value = volume*appVolume
                
        this.props.mediaSrc.connect(this.props.gainNode);
        this.props.gainNode.connect(this.props.audioCtx.destination);

        this.setState({initialVolumeSet: true})


        },500)

      }

      if(!this.state.initialLoad) {
        this.setState({initialLoad: true})
      }

    }

    async toggleAmbient(e) {
      console.log(e.target.checked)

      const { setAmbient } = this.context;

      if(e.target.checked) {
        await setAmbient(true)
        await this.playBackgroundAudio('toggle', 1)
      } else {
        await setAmbient(false)
        await this.playBackgroundAudio('toggle', 0)
      }

    }

    async toggleDayNight(e) {
      console.log(e.target.checked)

      const { setTime } = this.context;

      if(e.target.checked) {
        
        await setTime(true)

      } else {
        
        await setTime(false)

      }

      this.forceUpdate()

      await this.checkDayNight()
    }

     async checkDayNight() {
      const { activeView, time, viewLocation, backgroundAudio, backgroundAudioLevels, heatpumpAudioLevels, productSelected } = this.context;

      //console.log("CHECK DAY NIGHT");
      
      if(this.state.selectedProduct !== productSelected) {
        await this.setState({selectedProduct: productSelected})
        console.log("SET TO ...")
      }
      await console.log(this.state.selectedProduct)

        if(time) {
          if(viewLocation === 'outdoor') {
            this.playBackgroundAudio(backgroundAudio[2],backgroundAudioLevels['outdoorNight']);
            
          } else {
            this.playBackgroundAudio(backgroundAudio[3],backgroundAudioLevels['indoorNight']);
            
          }
        } else {
          if(viewLocation === 'outdoor') {
            this.playBackgroundAudio(backgroundAudio[0],backgroundAudioLevels['outdoorDay']);

            
          } else {
            this.playBackgroundAudio(backgroundAudio[1],backgroundAudioLevels['indoorDay']);
          }
        }

      switch (true) {
        case (activeView === 0 && !time):
           await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor3mDay'],0,'time');
          break;
        case (activeView === 0 && time):
            await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor3mNight'],0,'time');
          break;
        case (activeView === 1 && !time):
           await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor1mDay'],1,'time');
          break;
        case (activeView === 1 && time):
           await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor1mNight'],1,'time');
          break;
        case (activeView === 2 && !time):
           await this.playHeatpumpAudio('indoor',heatpumpAudioLevels['indoorDay'],2,'time');
          break;
        case (activeView === 2 && time):
           await this.playHeatpumpAudio('indoor',heatpumpAudioLevels['indoorNight'],2,'time');
          break;
        default:
      }

    }

    adaptZoom(zoom) {
      
      this.props.action(zoom);
    }

     async changeViewTest(e) {

      var activeToInt = parseInt(e.target.value);

      const { setActiveView} = this.context;

      setActiveView(activeToInt)
      
      console.log(e.target.value)

      this.changeProduct(e)



    }

    async changeViewTestTwo(value) {
      
      

    }

    onSliderChange = value => {

      var activeToInt = parseInt(value);

      const { setActiveView } = this.context;

      setActiveView(activeToInt);

      this.changeProduct(value,'slider')
        
      };


    async changeProduct(e,origin) {

      if(origin) {
        var value = e.toString();
      } else {
        value = e.target.value;
      }

      const { time, heatpumpAudioLevels } = this.context;

      switch (true) {
        case (value === '0' && !time):
          await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor3mDay'],0);
          await this.adaptZoom(3)
          break;
        case (value === '0' && time):
          await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor3mNight'],0);
          await this.adaptZoom(3)
          break;
        case (value === '1' && !time):
          await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor1mDay'],1);
          await this.adaptZoom(1)
          break;
        case (value === '1' && time):
          await this.playHeatpumpAudio('outdoor',heatpumpAudioLevels['outdoor1mNight'],1);
          await this.adaptZoom(1)
          break;
        case (value === '2' && !time):
        await this.playHeatpumpAudio('indoor',heatpumpAudioLevels['indoorDay'],2);
          await this.adaptZoom(0)
          break;
        case (value === '2' && time):
          await this.playHeatpumpAudio('indoor',heatpumpAudioLevels['indoorNight'],2);
          await this.adaptZoom(0)
          break;
        default:
      }

      await this.checkDayNight()
    }

    navigateHome = () => {
      this.props.history.push(`/${ this.props.lang }/setup`);
    }

    menuToggle = () => {
      const { menuOpen, setMenu, setMenuFloating} = this.context;

      if(menuOpen) {
        setMenu(false)
        
        setTimeout(() => {
          setMenuFloating(true)
        }, 300)
      } else {
        setMenu(true)
        setMenuFloating(false)
      }
      
    }

    render() {

      const { time, activeView, productSelected, menuOpen, ambientAudio } = this.context;

      const { t } = this.props;

      const renderControlButtons = () => {
          return  ( 
          <div id="sideMenu" className={menuOpen? styles.fadeIn: styles.fadeOut}>

            <div className={styles.menuHeader}>

              <div className={styles.menuSettingsText}>
                <h4 style={{ fontSize: '17px', fontFamily: 'Bosch-Bold'}}>{t('ui.distance.settings')}</h4>
              </div>
              <div>
              <Button className={styles.distanceBtn} onClick={() => { this.navigateHome() }}><FaHouseUser style={{color: '#FFF', fontSize: '22px'}} /></Button>
           
              </div>
            </div>
            
            <Menu lang={ this.props.lang } product={ productSelected } action={ this.changeHeatpumpAudio } />

            
            <div style={{margin: '0 0 30px 0', textAlign: 'left'}}>
            <label style={{ fontSize: '14px', fontFamily: 'Bosch-Bold'}}>{t('ui.distance.distance')}</label>
            <Form>
              <FormGroup style={{width: 'calc(100% - 16px)', height: '20px', marginLeft: '0px', marginTop: '10px'}}>
                <Slider
                        min={0}
                        max={2}
                        value={activeView}
                        trackStyle={{ backgroundColor: 'white', height: 10 }}
                        railStyle={{ backgroundColor: 'transparent', width: 'calc(100% + 16px)', height: 50, cursor: 'pointer'}}
                        handleStyle={{
                          borderColor: '#008ECF',
                          height: 18,
                          width: 18,
                          marginLeft: 8,
                          marginRight: 8,
                          marginTop: 0,
                          backgroundColor: '#008ECF',
                        }}
                        onChange={this.onSliderChange}
                        />
              </FormGroup>
            </Form>

            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', fontFamily: 'Bosch-Regular', fontSize: '12px' }}>
              <div className={activeView === 0? styles.thickBlue: styles.thinGray} style={{marginLeft: '7px'}}></div>
              <div className={activeView === 1? styles.thickBlue: styles.thinGray}></div>
              <div className={activeView === 2? styles.thickBlue: styles.thinGray} style={{marginRight: '7px'}}></div>
            </div>
            
            <div>
              <hr style={{marginTop: '0', marginBottom: '0', height: '0px', borderBottom: '1px solid #666666'}} />
            </div>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', fontFamily: 'Bosch-Regular', fontSize: '12px', marginTop: '4px' }}>
              <div>{t('ui.distance.3meter')}</div>
              <div>{t('ui.distance.1meter')}</div>
              <div><FaBed style={{fontSize: '18px', color: '#666666'}} /></div>
            </div>

                  
            </div>
            
            <hr style={{marginTop: '27px', marginBottom: '27px', height: '0px', borderBottom: '1px solid #666666'}} />
            
            <ToggleAudio />

            <hr style={{marginTop: '27px', marginBottom: '27px', height: '0px', borderBottom: '1px solid #666666'}} />
            

            <div style={{display: 'flex', justifyContent: 'space-between'}}>
            <div style={{paddingTop: '5px', paddingRight: '10px',  fontSize: '14px', fontFamily: 'Bosch-Bold'}}>
            {t('ui.distance.ambient')}
            </div>
            <div>
              <label className={ styles.switch }>
                <input type="checkbox" checked={ ambientAudio } onChange={(e) => { this.toggleAmbient(e)}} />
                <span className={ styles.slider + ' ' + styles.round } ></span>
              </label>
              
            </div>
            </div>

            <hr style={{marginTop: '27px', marginBottom: '27px', height: '0px', borderBottom: '1px solid #666666'}} />

            <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '20px', marginBottom: '20px'}} className={styles.flexContainer}>
                <div style={{paddingTop: '5px', paddingRight: '10px', fontSize: '14px', fontFamily: 'Bosch-Bold'}}>{t('ui.distance.nightmode')}</div>
                <div>
                  <label className={ styles.switch }>
                    <input type="checkbox" checked={ time } onChange={(e) => { this.toggleDayNight(e)}} />
                    <span className={ styles.slider + ' ' + styles.round } ></span>
                  </label>
                </div>
            </div>
            
          </div>
          )

      }


    return (
      <div className={`${styles.scaleContainer}`}>


      <MediaQuery minWidth={601}>
        <div className={menuOpen? styles.show: styles.hide} style={{position: 'fixed', width: '40px', height: '40px', right: '7px', top: '20px', zIndex: '999999999'}}>
              <Button onClick={() => { this.menuToggle() }} style={{borderRadius: '40px', width: '40px', height: '40px', background: '#038ecf', border: 'none', fontFamily: 'Bosch-Bold'}}>x</Button>
          </div>

          <div className={!menuOpen? styles.show: styles.hide} style={{position: 'fixed', width: '40px', height: '40px', right: '7px', top: '20px', zIndex: '999999999'}}>
              <Button onClick={() => { this.menuToggle() }} style={{borderRadius: '40px', width: '40px', height: '40px', background: '#038ecf', border: 'none', fontFamily: 'Bosch-Bold'}}> <FaChevronLeft /> </Button>
        </div>
      </MediaQuery>
      <MediaQuery maxWidth={600}>
        <div className={menuOpen? styles.show: styles.hide} style={{position: 'fixed', width: '40px', height: '40px', right: '7px', top: '0px', zIndex: '999999999'}}>
              <Button onClick={() => { this.menuToggle() }} style={{borderRadius: '40px', width: '40px', height: '40px', background: '#038ecf', border: 'none', fontFamily: 'Bosch-Bold'}}>x</Button>
          </div>

          <div className={!menuOpen? styles.show: styles.hide} style={{position: 'fixed', width: '40px', height: '40px', right: '7px', top: '20px', zIndex: '999999999'}}>
              <Button onClick={() => { this.menuToggle() }} style={{borderRadius: '40px', width: '40px', height: '40px', background: '#038ecf', border: 'none', fontFamily: 'Bosch-Bold'}}> <FaChevronDown /> </Button>
        </div>
      </MediaQuery>


      <div className={`${styles.controlBarContainer} ${menuOpen? styles.slideIn: styles.slideOut}`}>
    <div className={`${styles.distanceContainer}`}>


            { renderControlButtons() }

           { /* <audio id="heatpumpAudioContainer" className={styles.hide}
            controls
            loop
            src={require(`../../assets/audio/${ products[productSelected].audio[0] }`)}>
                Your browser does not support the
                <code>audio</code> element.
    </audio> */ }
        
            
        </div>
      </div>

      </div>
    );

  }
}

export default withRouter(withTranslation()(ControlPanel));